export default {
  // Hub (Referral.tsx)
  referral: 'Referral',
  commission_income: 'Commission income',
  todays_commission: "Today's commission",
  valid_team_bets_today: 'Valid team bets today',
  invitation_link: 'Invitation link',
  invitation_code: 'Invitation code',
  invitation_code_copied: 'Invitation code copied',
  view_link: 'View link',

  // Hub menu labels
  my_promotion: 'My promotion',
  commission_details: 'Commission details',
  team_management: 'Team management',
  team_members_report: 'Team members report',
  team_performance_report: 'Team performance report',
  team_3rd_party_bet_records: 'Team 3rd party bet records',
  team_account_change_records: 'Team account change records',

  // MyPromotion stats
  new_users_today: 'New users today',
  new_team_players_today: 'New team players today',
  team_betting_players_today: 'Team betting players today',
  direct_players: 'Number of direct players',
  total_team_players: 'Total team players',

  // CommissionDetails
  all_players: 'All players',
  game_time_col: 'Game/Time',
  commission_user_col: 'Commission/User',
  no_records: 'No records',

  // CommissionSettings
  commission_settings: 'Commission settings',
  earn_rebate: 'Earn Rebate',
  privilege_settings: 'Privilege Settings',
  commission_saved: 'Commission saved',
  save: 'Save',
  edit: 'Edit',
  confirm: 'Confirm',

  // CreateUser
  create_user: 'Create user',
  create: 'Create',
  account_placeholder: 'Account (6-10 alphanumeric combination)',
  account_invalid: 'Account must be 6-10 alphanumeric characters',
  account_no_special_chars: 'Special characters are not allowed',
  account_banned_word: 'This account name is not allowed',
  password_too_short: 'Password too short',
  user_created: 'User created',

  // TeamManagement
  search_uid_or_account: 'Please enter UID or account',
  no_members: 'No members',

  // TeamMembers
  all_user_type: 'All user type',
  new_users: 'New users',
  existing_users: 'Existing users',
  bet_users: 'Bet user',
  all_transaction_type: 'All transaction type',
  deposit: 'Deposit',
  withdraw: 'Withdraw',
  betting: 'Betting',
  select_user_type: 'Select user type',
  select_transaction_type: 'Select transaction type',
  account_count: 'Account',
  new_user_badge: 'New user',
  pnl: 'PnL',
  no_data: 'No data',
  direct_users: 'Direct users',
  sub_agent_team: 'Sub-agent team',
  valid_bet_amount: 'Valid bet amount',
  deposit_amount: 'Deposit amount',
  bonus_amount: 'Activity Bonus',
  withdrawal_amount: 'Withdrawal amount',
  register_time: 'Register time',

  // TeamPerformance — breakdown table
  game_type: 'Game type',
  valid_bets: 'Valid bets',
  team_pnl: 'Team PnL',
  commission: 'Commission',

  // TeamPerformance — top stats grid (emitted by fetchAgentTeamStats)
  stat_team_valid_bets: 'Team valid bets',
  stat_team_pnl: 'Team PnL',
  stat_my_commission: 'My commission',
  stat_activity_bonus: 'Activity Bonus',
  stat_team_size: 'Team size',
  stat_valid_users: 'Valid users',
  stat_new_users: 'New users',
  stat_withdrawer_count: 'Number of withdrawers',
  stat_withdrawal_amount: 'Withdrawal amount',
  stat_team_balance: 'Team Balance',
  stat_depositor_count: 'Number of deposit users',
  stat_deposit_amount: 'Deposit amount',
  stat_bettor_count: 'Number of bettors',
  stat_total_rebate_commission: 'Total rebate commission',

  // ThirdPartyBets
  all_3rd_party: 'All 3rd party',
  all_users: 'All users',
  select_provider: 'Select provider',

  // AccountChange
  all_type: 'All type',
  state_profit: 'Profit',
  state_loss: 'Loss',
  state_pending: 'Pending',
  state_reserved: 'Reserved',
  state_rollback: 'Rollback',
  state_cancel_order: 'Cancel order',
  state_draw: 'Draw',
  select_type: 'Select type',
  account_change_amount: 'Account change amount',
  account_change_details: 'Account change details',
  order_number: 'Order number',
  account: 'Account',
  account_change_type: 'Account change type',
  // Backend enum values from services/api/internal/agentreport/service.go.
  account_change_type_deposit: 'Deposit',
  account_change_type_withdraw: 'Withdraw',
  account_change_type_withdraw_rollback: 'Withdrawal reversal',
  account_change_type_game_bet: 'Game bet',
  account_change_type_game_win: 'Game win',
  account_change_type_game_refund: 'Game refund',
  account_change_type_game_rollback: 'Game rollback',
  account_change_type_instant_recharge: 'Instant recharge',
  account_change_type_collect_recharge: 'Collect recharge',
  account_change_type_reward: 'Reward',
  account_change_type_rebate: 'Rebate',
  account_change_type_commission: 'Commission',
  game_name: 'Game name',
  change_amount: 'Change amount',
  before: 'Before',
  after: 'After',
  time: 'Time',
  copied: 'Copied',

  // InvitationLink
  invitation_link_page: 'Invitation Link',
  link_details: 'Link details',
  create_a_link: 'Create a link',
  link_note: 'Note: Players who enter the platform and register through the corresponding link will enjoy the rebate provided by that link.',
  set_as_default: 'Set as default',
  details: 'Details',
  qr_code: 'QR code',
  qr_code_preview: 'QR code preview',
  save_qr: 'Save QR',
  qr_saved: 'QR code saved',
  qr_copied: 'QR code copied — paste it anywhere',
  // Shown when no save route was reachable at all. Names both gestures
  // because the one that rescues the user differs by client: long-press on
  // touch, right-click on desktop.
  qr_save_blocked: 'Save blocked — long-press or right-click the QR code to save it',
  link_copied: 'Link copied',
  normal_url: 'Normal url',
  tg_url: 'TG url',
  zero_commission: 'Default invitation link',
  enter_link_name: 'Please enter the link name',
  link_created: 'Link created',
  delete_link: 'Delete link',
  delete_link_confirm: 'Are you sure you want to delete this invitation link? This action cannot be undone.',
  link_deleted: 'Link deleted',

  // PasswordField
  show_password: 'show password',
  hide_password: 'hide password',

  // RatePickerSheet
  select_rate: 'Select rate',

  // RebateLevelTable
  rebate_level: 'Rebate level',
  total_betting_amount: 'Total betting amount',
  rebate_rate: 'Rebate rate',
  bet_category: 'Bet category',
  gameplay: 'Gameplay',
};
